import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
import { useField } from "formik";
import { InputGroup } from "react-bootstrap";
import InputGroupText from "react-bootstrap/esm/InputGroupText";

//App
import { TextFieldProps } from "../../../../types";

const TextFieldInput: React.FC<TextFieldProps> = ({
    id,
  label,
  name,
  type = "text",
  isRequired,
  onChange,
  onKeyDown,
    disabled,
}) => {
  const [field, meta] = useField(name);
  const { onChange: fieldOnChange, value, ...fieldProps } = field;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Formik's onChange handler
    fieldOnChange(e);

    // Custom onChange, if provided
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <>
      <Input
        type={type}
        value={value ?? undefined}
        {...fieldProps}
        id={id ?? name}
        name={name}
        placeholder={label}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        invalid={meta?.touched && !!meta?.error}
        disabled={disabled}
      />
      {label && <Label for={name}>{isRequired ? `${label} *` : label}</Label>}
      {meta?.touched && meta?.error && (
        <FormFeedback>{meta?.error}</FormFeedback>
      )}
    </>
  );
};

const PrependTextField: React.FC<TextFieldProps> = (props) => {
  const { prepend, style } = props;
  return (
    <FormGroup floating>
      {prepend ? (
              <InputGroup style={style }>
          <InputGroupText>{prepend}</InputGroupText>
          <TextFieldInput {...props} />
        </InputGroup>
      ) : (
        <TextFieldInput {...props} />
      )}
    </FormGroup>
  );
};

export default PrependTextField;
